import React from 'react';
import { Game } from './types';

const variants = [
  { activation: 'Included', label: 'С активацией', style: 'border-violet-500/25 bg-violet-500/10 text-violet-700 dark:text-violet-300' },
  { activation: 'NotIncluded', label: 'Без активации', style: 'border-foreground/10 bg-foreground/5 text-foreground/80' },
] as const;

const formatPrice = (price: number) => new Intl.NumberFormat('ru-RU').format(price);

export default function SharingPrices({ game }: { game: Pick<Game, 'purchaseOffers' | 'listDLC'> }) {
  const offers = [
    ...(game.purchaseOffers ?? []).map(offer => ({ offer, edition: false })),
    ...(game.listDLC ?? []).flatMap(dlc => (dlc.purchaseOffers ?? []).map(offer => ({ offer, edition: true }))),
  ].filter(({ offer }) => offer.isAvailable && offer.fulfillmentType === 'SharedAccount' && offer.price > 0);

  return (
    <dl aria-label="Цены шеринга" className="mt-3 space-y-2">
      {variants.map(({ activation, label, style }) => {
        const matching = offers.filter(({ offer }) => offer.activationType === activation);
        const price = matching.length ? Math.min(...matching.map(({ offer }) => offer.price)) : null;
        const from = matching.some(({ edition }) => edition);
        return (
          <div key={activation} className={`rounded-xl border px-2.5 py-2 sm:px-3 ${style}`}>
            <dt className="text-[11px] font-medium leading-4 sm:text-xs">{label}</dt>
            <dd className="mt-0.5">
              {price !== null ? (
                <span className="whitespace-nowrap text-base font-semibold tabular-nums sm:text-lg">
                  {from && <span className="text-xs font-normal">от </span>}{formatPrice(price)} ₽
                </span>
              ) : <span className="text-xs text-foreground/50">Нет в наличии</span>}
            </dd>
          </div>
        );
      })}
    </dl>
  );
}
